import React from 'react';
import { graphql } from 'react-relay';
import { Query } from '../../index';
import { populateChildren } from '../toolbox';

export const QWidgetQuery = graphql`
  query QWidgetQuery($widgetId: ID!, $fromTeamId: ID, $variables: JSON) {
    widget(widgetId: $widgetId, fromTeamId: $fromTeamId, variables: $variables) {
      id
      teamId
      name
      nbColsGrid
      heightRowsGrid
      contents
      hasReplacedVariables
      isLateEdit
      scope
      offerId
      isUsed
      isUsedBy {
        id
        name
      }
      version {
        versionId
        status
        itemScope
        itemType
        itemId
        major
        minor
        reviewComments {
          comments
          rejectionReason
          status
        }
      }
      orientation
      frameStyle {
        backgroundColor
        borderColor {
          top
          left
          right
          bottom
        }
        borderWidth {
          top
          left
          right
          bottom
        }
        borderStyle {
          top
          left
          right
          bottom
        }
        borderRadius {
          topLeft
          topRight
          bottomLeft
          bottomRight
        }
      }
    }
  }
`;

const QWidget = ({
  args,
  children,
  childDataProp
}) => (
  <Query
    args={args}
    query={QWidgetQuery}
  >
    {populateChildren('widget')(children, childDataProp)}
  </Query>
);

export default QWidget;
